import { Action, JobPostings } from 'types';

export type JobPostingsReducer = JobPostings | null;

const initialState: JobPostingsReducer = null;

export default (
  state: JobPostingsReducer = initialState,
  action: Action
): JobPostingsReducer => {
  switch (action.type) {
    case 'GET_JOB_POSTINGS_FULFILLED':
      return action.payload;
    default:
      return state;
  }
};
